(() => {
  angular
    .module('complianceFrameworkApp.socialMediaCompliance')
    .controller('PagePostsController', PagePostsController);

  /* ngInject */
  function PagePostsController($stateParams, sessionService, pagePostService) {
    const vm = this;

    vm.currentPage = $stateParams.currentPage || 1;
    vm.loading = false;
    vm.pageChange = pageChange;
    vm.pagePosts = [];
    vm.totalCount = null;

    activate();

    function activate() {
      getPagePosts();
    }

    function getPagePosts() {
      vm.loading = true;

      pagePostService(sessionService.getAuthToken()).query({ 'page': vm.currentPage }, response => {
        vm.loading = false;
        vm.pagePosts = response.data;
        vm.totalCount = parseInt(response.headers['x-total']);
      }, _ => {
        vm.loading = false;
      });
    }

    function pageChange(newPageNumber, _oldPageNumber) {
      vm.pagePosts = [];
      vm.currentPage = newPageNumber;
      getPagePosts();
    }
  }
})();
